module.exports = __webpack_public_path__ + "static/media/down_arrow.dcdc4692.svg";